// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import React, { useState, useEffect } from "react";
import { Container, Modal, Row, Col } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input, Select } from "../../../_metronic/_partials/controls";
import Map from "../../../_metronic/layout/components/mapbox";
import { states } from "./state"
import * as regions from "../CatalogRegions/operations"
import { ClientEditModal as RegionModal } from "../CatalogRegions/editModal"

import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
// Validation schema
const CustomerEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(120, "Maximum 120 symbols")
    .required("Field is necesssary"),
  description: Yup.string().optional(),
  region: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(500, "Maximum 500 symbols")
    .optional("Field is necesssary"),
  contact: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .optional("Field is Optional"),
  phone: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .optional("Field is Optional"),
  email: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .optional("Field is Optional"),
  address: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(500, "Maximum 500 symbols")
    .optional("Field is necesssary"),

  state: Yup.string()
    .max(50, "Maximum 50 symbols")
    .optional(),
  city: Yup.string()
    .max(50, "Maximum 50 symbols")
    .optional(),
  zipcode: Yup.string()
    .max(50, "Maximum 50 symbols")
    .optional(),
});
/* const AVAILABLE_LOCATIONS = ["--null--", "Arizona", "Texas"]; */
export function ClientEditForm({
  update,
  client,
  actionsLoading,
  handleClose,
}) {
  function updateLocation(coordinates) {
    client["coordinates"] = coordinates;
  }

  function resizedataURL(datas, wantedWidth, wantedHeight) {
    return new Promise(async function (resolve, reject) {

      // We create an image to receive the Data URI
      var img = document.createElement('img');

      // When the event "onload" is triggered we can resize the image.
      img.onload = function () {
        // We create a canvas and get its context.
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');

        // We set the dimensions at the wanted size.
        canvas.width = wantedWidth;
        canvas.height = wantedHeight;

        // We resize the image with the canvas method drawImage();
        ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);

        const dataURI = canvas.toDataURL();

        // This is the return of the Promise
        resolve(dataURI);
      };

      // We put the Data URI in the image's src attribute
      img.src = datas;

    })
  }
  function updatePhoto({ target }) {
    const [file] = target.files;
    const reader = new FileReader();
    reader.addEventListener(
      "load",
      ({ target }) => {
        resizedataURL(target.result, 600, 600)
          .then((data) => {
            setImage(data)
            client["image"] = data
          })

      },
      false
    );
    if (file) {
      reader.readAsDataURL(file);
    }
  }

  const [zipcode, setZip] = useState(client.zipcode || "")
  const [state, setState] = useState(client.state || "Alabama")
  const [city, setCity] = useState(client.city || "Auburn")
  const [address, setAddres] = useState(client.address || "")
  const [_regions, setRegions] = useState([])

  const [image, setImage] = useState(client.image);
  function replace(string, slice) {
    return String(string).replace(slice, "").trim()
  }

  function setContext(contexts, data) {
    if (data.place_name) {
      setAddres(data.place_name)
    }
    const keys = {
      "postcode": {
        controller: setZip,
        field: "zipcode"
      },

      "region": {
        controller: setState,
        field: "state"
      },
      "place": {
        controller: setCity,
        field: "city",
        extra: (e) => replace(e, "City")
      },
    }
    for (const key of Object.keys(keys)) {
      const [context] = [...contexts].filter(context => {
        return context.id.includes(key)
      })
      if (!context) {
        continue
      }
      const extra = keys[key]["extra"]
      const value = extra ? extra(context.text) : context.text
      const controller = keys[key]["controller"]
      controller(value)

    }
  }
  useEffect(() => {
    regions.getClients(setRegions)
  }, [])
  const [isSubmitting, setSubmitting] = useState(false)
  const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };
  const [add_region, set_add_region] = useState(false)
  const _update = (args) => {
    regions.updateClient(args).then(() => {
      regions.getClients((data ) => {
        setRegions(data)
        set_add_region(false)

      });
    })
  }
  return (

    <>
      <RegionModal update={_update} show={add_region} handleClose={() => set_add_region(!add_region)} client={{}} />
      <Formik
        enableReinitialize={true}
        validateOnChange={false}
        validateOnBlur={false}
        initialValues={client}
        validationSchema={CustomerEditSchema}
        onSubmit={(values) => {
          update({ ...client, coordinates: { longitude: 0, latitude: 0 }, ...values, ...{ city, state, zipcode }, address })
            .then(() => setSubmitting(false))
            .end((err) => {
              setSubmitting(false)
            })
        }}
      >
        {({ handleSubmit, errors, handleChange, values }) => (
          <>
            <Modal.Body className="  cursor-default">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Form className="form form-label-right">
                <div className="form-group row">
                  <div className="col-lg-8">
                    <Map
                      height="595px"
                      controller={updateLocation}
                      setContext={setContext}
                      location={client}
                      errors={errors}
                      onChange={handleChange}
                      zoom={client.uid ? 15 : 3}
                      traces={[]}
                    />
                    <div className="row mt-4">
                      <div className="col">
                        <Field
                          onInput={toInputUppercase}

                          onChange={({ target }) => setAddres(target.value)}
                          value={address}
                          name="address"
                          component={Input}
                          errors={errors}
                          placeholder="address"
                          label="address"
                        />
                      </div>
                      <div className="col">
                        <Field
                          onInput={toInputUppercase}

                          name="description"
                          value={(values.name ?? "") + " - " + (address ?? "")}
                          onChange={handleChange}
                          component={Input}
                          errors={errors}
                          placeholder="Description"
                          label="Description"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="col-lg-2">
                      <h6>Image</h6>
                      <div className="col-lg-4 col-xl-6">
                        <div
                          className="image-input image-input-outline"
                          id="kt_profile_avatar"
                        >
                          <div
                            className="image-input-wrapper"
                            style={{
                              backgroundImage: `url(${image})`,
                            }}
                          ></div>
                          <label
                            className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                            data-action="change"
                            data-toggle="tooltip"
                            title=""
                            data-original-title="Change avatar"
                          >
                            <i className="fa fa-pen icon-sm text-muted"></i>
                            <input
                              type="file"
                              name="profile_avatar"
                              accept=".png, .jpg, .jpeg"
                              onChange={updatePhoto}
                            />
                            <input
                              type="hidden"
                              name="profile_avatar_remove"
                            />
                          </label>
                          <span
                            className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                            data-action="cancel"
                            data-toggle="tooltip"
                            title="Cancel avatar"
                          >
                            <i className="ki ki-bold-close icon-xs text-muted"></i>
                          </span>
                          <span className="form-text text-muted">
                            Allowed file types: png, jpg, jpeg.
                                </span>
                          <br />
                        </div>
                      </div>
                    </div>

                    <Field
                      name="name"
                      component={Input}
                      value={values.name}
                      onChange={handleChange}
                      onInput={toInputUppercase}
                      errors={errors}
                      placeholder="Location Name"
                      label="Location Name"
                    />
                    <br />

                    <Field
                      name="contact"
                      onInput={toInputUppercase}
                      component={Input}
                      placeholder="Contact Name"
                      errors={errors}
                      onChange={handleChange}

                      label="Contact Name"
                    />
                    <br />
                    <Field
                      onInput={toInputUppercase}
                      name="phone"
                      component={Input}
                      errors={errors}
                      onChange={handleChange}
                      placeholder="Phone Number"
                      label="Phone Number"
                    />
                    <br />
                    <Field
                      onInput={toInputUppercase}
                      name="email"
                      component={Input}
                      placeholder="Email"
                      errors={errors}
                      onChange={handleChange}
                      label="Email"
                    />
                    <br />

                    <Field
                      onInput={toInputUppercase}
                      value={zipcode}
                      name="zipcode"
                      onChange={({ target }) => setZip(target.value)}
                      component={Input}
                      placeholder="ZIPCODE"
                      errors={errors}
                      label="ZIPCODE"
                    />

                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-lg-4 col-xs-12">

                    <Select name="state" label="state" onChange={({ target }) => setState(target.value)} value={state}>
                      {Object.keys(states)
                        .sort()
                        .map((state, key) => (
                          <option
                            key={key}
                            value={state}
                          >
                            {state}
                          </option>
                        ))}
                    </Select>
                  </div>
                  <div className="col-lg-4 col-xs-12">
                    <Select name="city" label="City" onChange={({ target }) => setCity(target.value)} value={city}>
                      {(states[state] || [])
                        .sort()
                        .map((city, key) => (
                          <option
                            key={key}
                            value={city}
                          >
                            {city}
                          </option>
                        ))}
                    </Select>

                  </div>
                  <div className="col-lg-4 col-xs-12">
                    <div className="d-flex justify-content-between">
                      <label>Select Region</label>
                      <button
                        style={{ marginTop: "-10px" }}
                        title="Add region"
                        className="btn btn-icon btn-light btn-hover-success btn-sm align-top"
                        onClick={() => { set_add_region(true) }}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-success">
                          <SVG
                            src={toAbsoluteUrl("/media/svg/icons/Communication/Flag.svg")}
                          />
                        </span>
                      </button>
                    </div>
                    <Select name="region" >
                      <option value="-null-">
                        -null-
                      </option>
                      {[..._regions]
                        .filter(r => r.state === state)
                        .sort()
                        .map((region, key) => (
                          <option
                            key={key}
                            value={region.uid}
                          >
                            {region.name}
                          </option>
                        ))}
                    </Select>
                  </div>

                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer>

              <button
                type="button"
                onClick={handleClose}
                className="btn btn-light btn-elevate"
              >
                Cancel
                </button>
              <> </>
              <button
                type="submit"
                onClick={async () => {
                  setSubmitting(true)
                  handleSubmit()
                  setTimeout(() => setSubmitting(false), 500)

                }}
                disabled={isSubmitting}
                className="btn btn-primary btn-elevate"
              >
                {isSubmitting ?
                  <div className="d-flex align-items-center">
                    <div className="mr-2">Loading...</div>
                    <div className="spinner spinner-white mr-10"></div>
                  </div> : "Save"}
              </button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}
export function ClientEditModal(props) {
  return (
    <>
      <Modal
        show={props.show}
        onHide={props.handleClose}
        size="xl"
      >
        <Modal.Header>
          <h1>{props.client.uid ? "Edit POS" : "New POS"}</h1>
        </Modal.Header>

        <ClientEditForm {...props} />
      </Modal>
    </>
  );
}
export function ClienDeleteModal(props) {
  return (
    <>
      <Modal
        show={props.delete}
        onHide={props.hideDelete}
        dialogClassName="p-5"
      >
        <Modal.Header>
          <h1>Delete POS</h1>
        </Modal.Header>
        <Modal.Body>
          Are you sure to permanently delete this <b>POS</b>?
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            onClick={props.hideDelete}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="submit"
            onClick={() => props.deleteClient(props.client.uid)}
            className="btn btn-danger btn-elevate"
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export function PreviewModal(props) {
  const [state, setState] = useState("-all-")
  const [city, setCity] = useState("-all-")
  const [region, setRegion] = useState("-all-")
  const [states, setStates] = useState([])

  useEffect(() => {
    setStates(props.states)
  }, [props.states])
  const data = props.pos.filter(pos => {
    if ("-all-" === state) { return true }
    return pos.state === state
  }).filter(pos => {
    if ("-all-" === city) { return true }
    return pos.city === city
  })
    .filter(pos => {
      if ("-all-" === region) { return true }
      return pos.region === region
    })
  console.log({ data })
  return (
    <Container>

      <Modal
        show={props.preview}
        onHide={props.togglePreview}
        dialogClassName="mw-75 min-vh-90 modal-xl"
        >
        <Modal.Header closeButton>
          <Modal.Title>
          <h1>Map</h1>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body >
        <div className="p-2">
          <Map
            preview={true}
            location={{}}
            height="60vh"
            pos={data}
          />
        </div>
          <hr />
          <div className="p-2">
            <h6 className="text-muted">Filter by</h6>
            <Row>
              <Col xs={2}>
                <label>State</label>
                <select
                  value={state}
                  className="form-control form-control-solid"
                  onChange={({ target }) => {
                    setCity("-all-");
                    setRegion("-all-");

                    setState(target.value)
                  }}>
                  <option value="-all-" >
                    -all-
                      </option>
                  {states
                    .sort()
                    .map((state, key) =>
                      <option value={state} key={key} >
                        {state}
                      </option>
                    )}
                </select>
              </Col>
              <Col xs={2}>
                <label>City</label>
                <select
                  value={city}
                  className="form-control form-control-solid"
                  onChange={({ target }) => setCity(target.value)}>
                  <option value="-all-" >
                    -all-
                      </option>
                  {(states[state] || [])
                    .sort()
                    .map((city, key) =>
                      <option value={city} key={key}>
                        {city}
                      </option>
                    )}
                </select>
              </Col>
              <Col xs={2}>
                <label>Region</label>
                <select
                  value={region}
                  className="form-control form-control-solid"
                  onChange={({ target }) => setRegion(target.value)}>
                  <option value="-all-" >
                    -all-
                  </option>
                  {props.regionList
                    .filter(region => {
                      if ("-all-" === state) { return true }
                      return region.state === state
                    })
                    .map((region) =>
                      <option value={region.uid} key={region.uid}>
                        {region.name}
                      </option>
                    )}
                </select>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal >
    </Container>

  )
}